import { HTTP } from '@/api/http-common'
import { HttpFunctions } from '@/api/http-functions'

export default {
  getVariantAttrubutes (productId, callback) {
    if (productId !== undefined) {
      HTTP.get('products/' + productId + '/attribute').then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 400) {
          console.log('Error: required data is missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  addVariantAttributes (param, callback) {
    if (param !== undefined) {
      HTTP.post('products/variant', param).then(response => {
        if (response.status === 201) {
          callback(response)
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  getProductVariants (param, callback) {
    if (param !== undefined) {
      let url = 'products/' + param.productId + '/variant'
      url += '?_page=' + param.search.page + '&_limit=' + param.search.limit + '&_sort=' + param.search.sort + '&_order=' + param.search.order

      HTTP.get(url).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 400) {
          console.log('Error: required data is missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  setProductVariant (param, callback) {
    if (param !== undefined) {
      HTTP.put('products/variant', param).then(response => {
        if (response.status === 201) {
          callback(response)
        } else if (response.status === 400) {
          console.log('Error: required data is missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  deleteProductVariant (param, callback) {
    if (param !== undefined) {
      HTTP.delete('products/variant', { data: param }).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 400) {
          console.log('Error: required data is missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  uploadProductVariantImage (body, callback) {
    HTTP.post('products/variant/image', body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getProductVariantImages (productVariantId, callback) {
    if (productVariantId !== undefined) {
      HTTP.get('products/variant/image/' + productVariantId).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 400) {
          console.log('Error: required data is missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  deleteProductVariantImages (param, callback) {
    if (param.image_id !== undefined) {
      HTTP.delete('products/variant/image', { data: param }).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 400) {
          console.log('Error: required data is missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  updateProductVariantImage (body, callback) {
    let imageId = body.get('image_id')
    HTTP.post('products/variant/image/' + imageId, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  updateVariantImagesOrder (body, callback) {
    HTTP.put('products/variant/image', body).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 400) {
        console.log('Error: images is required')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  generateProductVariantsAPI (param, callback) {
    if (param !== undefined) {
      HTTP.post('/generate/products/variant', param).then(response => {
        if (response.status === 201) {
          callback(response)
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  updateProductVariantListData (param, callback) {
    if (param !== undefined) {
      HTTP.put('/products/variant/list', param).then(response => {
        if (response.status === 201) {
          callback(response)
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  deleteAllProductVariant (param, callback) {
    if (param !== undefined) {
      HTTP.delete('products/variant/list', { data: param }).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 400) {
          console.log('Error: required data is missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/products/variants/index.js